export default "__VITE_ASSET__B_TxZ8il__"